module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/cs-card-drag.45f7b47656a76e2c9b63.gif";